// @flow
import React, { type Node } from 'react';

import Loading from 'app/common/components/Loader';
import type { SubjectList } from 'app/dataTypes/ScheduleWeek.types';

import ScheduleTable from './ScheduleTable';
import ScheduleTableContent from './ScheduleTableContent';
import styles from './ScheduleDay.scss';


type Props = {
  weekDay: string,
  loading: boolean,
  title: string,
  data: SubjectList | null,
  studentId: string,
}

const emptyData: SubjectList = [];

const ScheduleDay = ({ weekDay, loading, title, data, studentId }: Props): Node => {
  return (
    <div className={styles.root}>
      <div className={styles.day}>
        {title}
      </div>

      <ScheduleTable weekDay={weekDay}>
        {tab => (
          <ScheduleTableContent
            data={data || emptyData}
            currentTab={tab}
            studentId={studentId}
          />
        )}
      </ScheduleTable>

      {loading
        && <Loading className={styles.loading} />}
    </div>
  );
};

export default ScheduleDay;
